'use strict';

exports.__esModule = true;
exports.loaders = exports.dynamicArgumentsMap = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _widgetActions = require('../actions/widget-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 Here we specify where to find the arguments to replace in the loaders int the request.
 **/
var dynamicArgumentsMap = exports.dynamicArgumentsMap = {
    _profileId_: 'query.profileId',
    _profileType_: 'query.profileType',
    _link_: 'query.link',
    _layoutType_: 'query.layoutType',
    _responsiveId_: 'query.responsiveId',
    _customizations_: 'query.customizations'
};
var setupProfile = function setupProfile(profileId, profileType, baseUrl, link, layoutType, responsiveId, customizations, xhrConfig) {
    return function (dispatch) {
        if (profileType && profileType.substr(-1) !== 's') {
            profileType += 's';
        }

        try {
            customizations = JSON.parse(customizations);
        } catch (e) {}

        var _customizations = customizations,
            bodyStyle = _customizations.bodyStyle,
            blackAndWhiteTheme = _customizations.blackAndWhiteTheme,
            wrapperFrame = _customizations.wrapperFrame,
            isShrinked = _customizations.isShrinked;


        wrapperFrame = wrapperFrame === false || wrapperFrame === 'false' ? false : wrapperFrame;
        isShrinked = isShrinked === false || isShrinked === 'false' ? false : isShrinked;

        return _promise2.default.all([dispatch(_widgetActions.widgetActions.getProfileDetails(profileId, profileType, baseUrl)), dispatch(_widgetActions.widgetActions.getLayout({ link: link, layoutType: layoutType, responsiveId: responsiveId, bodyStyle: bodyStyle, blackAndWhiteTheme: blackAndWhiteTheme, wrapperFrame: wrapperFrame, isShrinked: isShrinked })), _widgetActions.widgetActions.loadReviewsStat(profileId, profileType, xhrConfig)(dispatch)]);
    };
};
var loaders = exports.loaders = [{
    key: 'profileId',
    action: setupProfile,
    arguments: ['_profileId_', '_profileType_', typeof process !== 'undefined' && 'https://www.doctify.co.uk', '_link_', '_layoutType_', '_responsiveId_', '_customizations_'],
    dynamicArguments: ['_profileId_', '_profileType_', '_link_', '_layoutType_', '_responsiveId_', '_customizations_']
}];